import { useCallback, useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/mediakit/Nav";
import Hero from "@/components/mediakit/Hero";
import About from "@/components/mediakit/About";
import Services from "@/components/mediakit/Services";
import Stats from "@/components/mediakit/Stats";
import Retreat from "@/components/mediakit/Retreat";
import Gallery from "@/components/mediakit/Gallery";
import MediaKit from "@/components/mediakit/MediaKit";
import Contact from "@/components/mediakit/Contact";
import Footer from "@/components/mediakit/Footer";
import CalendlyModal from "@/components/mediakit/CalendlyModal";

export default function App() {
  const [calendlyOpen, setCalendlyOpen] = useState(false);
  const openCalendly = useCallback(() => setCalendlyOpen(true), []);

  useEffect(() => {
    document.title = "Shawnie & Aunnie Presents... | Media Kit";
  }, []);

  return (
    <div className="min-h-screen bg-[#12281D] text-[#FBF9F1] antialiased">
      <Toaster position="top-center" richColors />
      <Nav />
      <main>
        <Hero onBook={openCalendly} />
        <About />
        <Services />
        <Stats />
        <Retreat onBook={openCalendly} />
        <Gallery />
        <MediaKit />
        <Contact onBook={openCalendly} />
      </main>
      <Footer />
      <CalendlyModal open={calendlyOpen} onOpenChange={setCalendlyOpen} />
    </div>
  );
}
